var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientOrderMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.297,
    height: 65.297,
    viewBox: "0 0 65.297 65.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16952"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": 898598
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 417",
    d: "M60.758 10H15.1a5.1 5.1 0 0 0-5.1 5.1v55.1a2.551 2.551 0 0 0 2.551 2.551h40.555a2.551 2.551 0 0 0 2.551-2.551V23.431z",
    transform: "translate(-8.725 -8.725)",
    style: {
      fill: "#faf8f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 419",
    d: "m262.492 260.242-1.826-3.173L248.875 256v4.242l-1.437 1.624a7.04 7.04 0 0 0-1.438 4.541v18.415c0 1.409.677 2.551 1.513 2.551h16.34c.836 0 1.513-1.142 1.513-2.551v-18.415a7.04 7.04 0 0 0-1.437-4.541z",
    transform: "translate(-201.345 -223.352)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 492",
    transform: "translate(34.944 25.507)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 420",
    d: "M298.231 207.142h-22.956a1.275 1.275 0 0 1-1.275-1.275v-4.591a1.275 1.275 0 0 1 1.275-1.276h22.956a1.275 1.275 0 0 1 1.275 1.275v4.591a1.275 1.275 0 0 1-1.275 1.276z",
    transform: "translate(-274 -200)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 82",
    cx: 9.182,
    cy: 9.182,
    r: 9.182,
    transform: "translate(3.571 14.276)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 421",
    d: "M79.3 69.1h-5.1V64h-5.1v5.1H64v5.1h5.1v5.1h5.1v-5.1h5.1z",
    transform: "translate(-55.838 -55.838)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 422",
    d: "M140.072 246h-8.8a1.275 1.275 0 0 0 0 2.551h8.8a1.275 1.275 0 1 0 0-2.551z",
    transform: "translate(-113.417 -214.627)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 423",
    d: "M59.141 246h-3.748a1.275 1.275 0 1 0 0 2.551h3.747a1.275 1.275 0 1 0 0-2.551z",
    transform: "translate(-47.216 -214.627)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 424",
    d: "M140.072 312h-8.8a1.275 1.275 0 0 0 0 2.551h8.8a1.275 1.275 0 1 0 0-2.551z",
    transform: "translate(-113.417 -272.21)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 425",
    d: "M59.141 312h-3.748a1.275 1.275 0 1 0 0 2.551h3.747a1.275 1.275 0 1 0 0-2.551z",
    transform: "translate(-47.216 -272.21)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 426",
    d: "M140.072 380.551a1.275 1.275 0 1 0 0-2.551h-8.8a1.275 1.275 0 0 0 0 2.551z",
    transform: "translate(-113.417 -329.792)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 427",
    d: "M59.141 378h-3.748a1.275 1.275 0 1 0 0 2.551h3.747a1.275 1.275 0 1 0 0-2.551z",
    transform: "translate(-47.216 -329.792)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 428",
    d: "m62.308 37.455-1.857-1.245v-2.631a2.55 2.55 0 0 0 1.275-2.206v-4.591a2.554 2.554 0 0 0-2.551-2.551H36.219a2.554 2.554 0 0 0-2.551 2.551v4.591a2.55 2.55 0 0 0 1.275 2.206v2.631l-1.858 1.245a6.731 6.731 0 0 0-2.988 5.6v18.416a3.808 3.808 0 0 0 .219 1.275H3.826a1.277 1.277 0 0 1-1.275-1.275V6.377a3.83 3.83 0 0 1 3.826-3.826h40.559a6.343 6.343 0 0 0-1.279 3.826v13.082a1.275 1.275 0 1 0 2.551 0V6.377a3.826 3.826 0 1 1 7.652 0v8.672h-4.719a1.275 1.275 0 1 0 0 2.551h5.994a1.275 1.275 0 0 0 1.275-1.275V6.377A6.384 6.384 0 0 0 52.033 0H6.377A6.384 6.384 0 0 0 0 6.377v55.094A3.83 3.83 0 0 0 3.826 65.3h57.645a3.83 3.83 0 0 0 3.829-3.829V43.056a6.731 6.731 0 0 0-2.992-5.601zM36.219 26.782h22.956v4.591h-2.267v-1.861a1.275 1.275 0 1 0-2.551 0v1.861h-2.74v-1.861a1.275 1.275 0 1 0-2.551 0v1.861h-2.74v-1.861a1.275 1.275 0 1 0-2.551 0v1.861h-2.74v-1.861a1.275 1.275 0 1 0-2.551 0v1.861h-2.265zm26.527 34.689a1.277 1.277 0 0 1-1.275 1.275H33.924a1.277 1.277 0 0 1-1.275-1.275V43.056a4.185 4.185 0 0 1 1.858-3.482l2.423-1.624a1.275 1.275 0 0 0 .565-1.059v-2.967H57.9v2.966a1.275 1.275 0 0 0 .565 1.059l2.423 1.624a4.185 4.185 0 0 1 1.858 3.482z",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 429",
    d: "M338.458 342.529h-3.316v-3.316a1.275 1.275 0 1 0-2.551 0v3.316h-3.316a1.275 1.275 0 1 0 0 2.551h3.316v3.32a1.275 1.275 0 1 0 2.551 0v-3.32h3.316a1.275 1.275 0 1 0 0-2.551z",
    transform: "translate(-286.169 -294.84)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 430",
    d: "M302.458 301.938a10.458 10.458 0 1 0 10.457 10.462 10.47 10.47 0 0 0-10.457-10.462zm0 18.365a7.907 7.907 0 1 1 7.907-7.907 7.916 7.916 0 0 1-7.907 7.904z",
    transform: "translate(-254.76 -263.431)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 431",
    d: "M65.478 54h-5.1a1.275 1.275 0 0 0-1.278 1.275V59.1h-3.825A1.275 1.275 0 0 0 54 60.377v5.1a1.275 1.275 0 0 0 1.275 1.275H59.1v3.826a1.275 1.275 0 0 0 1.275 1.275h5.1a1.275 1.275 0 0 0 1.275-1.275v-3.825h3.826a1.275 1.275 0 0 0 1.275-1.275v-5.1a1.275 1.275 0 0 0-1.272-1.278h-3.826v-3.825A1.275 1.275 0 0 0 65.478 54zm3.822 7.652V64.2h-3.822a1.275 1.275 0 0 0-1.278 1.278V69.3h-2.548v-3.822a1.275 1.275 0 0 0-1.275-1.278h-3.826v-2.548h3.826a1.275 1.275 0 0 0 1.275-1.275v-3.826H64.2v3.826a1.275 1.275 0 0 0 1.275 1.275z",
    transform: "translate(-47.113 -47.113)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 432",
    d: "M267.044 114a1.275 1.275 0 1 0 0 2.551h6.123a1.275 1.275 0 1 0 0-2.551z",
    transform: "translate(-231.875 -99.461)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 433",
    d: "M225.374 114.374a1.275 1.275 0 1 0 .9-.374 1.285 1.285 0 0 0-.9.374z",
    transform: "translate(-196.305 -99.461)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 434",
    d: "M49.786 429.015a1.275 1.275 0 0 0 1.8 0l1.01-1.01 1.567 1.567a2.54 2.54 0 0 0 3.588 0l2.53-2.53a1.275 1.275 0 1 0-1.8-1.8l-2.521 2.521-1.567-1.567a2.54 2.54 0 0 0-3.588 0l-1.019 1.019a1.275 1.275 0 0 0 0 1.8z",
    transform: "translate(-43.11 -370.681)",
    style: {
      fill: "#6f7e8e"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientOrderMedicine);
export default __webpack_public_path__ + "static/media/patientOrderMedicine.362292cdf067b8345c263728b7bb0ae0.svg";
export { ForwardRef as ReactComponent };